import React from "react";
import logo from "../assets/logo.svg"; // Логото ще го добавим.

const Banner = () => {
	return (
		<div className="banner">
			<img src={logo} alt="Airport Taxi Transfers Varna" className="logo" />
		</div>
	);
};

export default Banner;